// src/main.tsx

import React from 'react';
import ReactDOM from 'react-dom/client';
import './src/index.css';
import App from './src/App';
import { BrowserRouter } from 'react-router-dom';

async function bootstrap() {

    ReactDOM.createRoot(
        document.getElementById('root')!
    ).render(
        <React.StrictMode>
            <BrowserRouter>
            <App />
            </BrowserRouter>
        </React.StrictMode>
    );
}

bootstrap();